/* eslint-env browser */

import React from 'react';
import ReactDOM from 'react-dom';

import AppContainer from './AppContainer';
import './index.css';

ReactDOM.render(<AppContainer />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js